
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class IconChevron extends Vue {
  @Prop({ default: 12 }) size!: number;

  @Prop({ default: 0 }) rotation!: number;
}
